import React, { useEffect, useRef, useState } from 'react'
import styles from './WhatsappOverlay.module.css'
import { LangHaveQuestion, LangHelloHowCanIHelp, LangOurTeamReadyToHelp } from '../../../constant/languange'
import { connect, mapStateToProps } from '../../../helpers/Common'

function WhatsappOverlayComponent({ redux }) {
  const [config, setConfig] = useState({
    whatsapp_number: process.env.REACT_APP_WHATSAPP_OVERLAY_NUMBER,
    online_start_time: '06:00:00',
    online_end_time: '18:00:00',
    dark_mode: redux.darkModeOn === 1 ? true : false,
    content: {
      window_title: LangHaveQuestion,
      window_sub_title: LangOurTeamReadyToHelp,
      chat_cs_name: 'CS Kerjoo',
      chat_cs_title: 'Customer Support Kerjoo',
      chat_cs_image_url: 'https://raw.githubusercontent.com/almazary/public/refs/heads/master/kerjoo/cs-kerjoo.jpg',
      chat_message: LangHelloHowCanIHelp,
      label_online: 'Online',
      label_offline: 'Slow Response',
      input_placeholder_online: 'Reply to CS Kerjoo',
      input_placeholder_offline: 'Reply to CS Kerjoo (slow response)',
    }
  })
  const iframeRef = useRef()

  useEffect(() => {
    // receive height and width from iframe
    const handleMessage = (e) => {
      if (e.origin !== 'https://whatsapp-overlay.vercel.app') return
      const message = e.data
      if (message?.height && message?.width && iframeRef.current) {
        iframeRef.current.style.height = `${message.height}px`
        iframeRef.current.style.width = `${message.width}px`
      }
    }
    window.addEventListener('message', handleMessage, false)
    return () => window.removeEventListener('message', handleMessage, false)
  }, [])

  useEffect(() => {
    setConfig(currConfig => ({ ...currConfig, dark_mode: redux.darkModeOn === 1 ? true : false }))
  }, [redux.darkModeOn])

  useEffect(() => {
    iframeRef.current.contentWindow.postMessage(config, "*")
    // eslint-disable-next-line
  }, [config])

  const onLoad = () => {
    setTimeout(() => {
      // send config to iframe
      iframeRef.current?.contentWindow.postMessage(config, "*")
    }, 200)
  }

  return (
    <div className={styles.container}>
      <iframe
        id='wa-overlay'
        title='wa-overlay'
        src='https://whatsapp-overlay.vercel.app/'
        ref={iframeRef}
        onLoad={onLoad}
        style={{ border: 0, width: 72, height: 72, maxWidth: '95vw', position: 'absolute', bottom: 5, right: 0 }}
      >
      </iframe>
    </div>
  )
}

export default connect(mapStateToProps)(WhatsappOverlayComponent)
